import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import GlobalApi from "./../../Global";
import refresh_token from "./../../Global/refresh_token";
import MiddleHeader from "../middleHeader/middleHeader";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import { SearchBar } from "./executiveDashFilter";
import CloseIcon from "@material-ui/icons/Close";
import {useTranslation} from 'react-i18next';

//Config components
import { useHistory } from "react-router-dom";
import { Redirect } from "react-router";
import Colors from "./../../Global/colors";
import moment from "moment";

//Custom Css + Images
import Filter from "../../Assets/filter.png";

//Redux
import { useSelector, useDispatch } from "react-redux";

//Views
import Dashboard1 from "./executiveDash1";
import Dashboard2 from "./executiveDash2";
import Dashboard3 from "./executiveDash3";

const AntTabs = withStyles({
  root: {
    backgroundColor: "#ffffff",
    color: "#222",
  },
  indicator: {
    backgroundColor:'#1a73e8'
    // display:'none'
  },
})(Tabs);

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      style={{ backgroundColor: Colors.backgroundColor }}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={0}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function ExecutiveDashNav() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  let language = useSelector((state) => state.languageReducer.language);
  let companies = useSelector((state) => state.companyArrReducer.company);
  let currentCompany = useSelector((state) => state.companyReducer.company.id);

  const classes = useStyles();
  const history = useHistory();
  const [tabvalue, setTabValue] = React.useState(0);
  const [btnLoader, setBtnLoader] = React.useState(false);

  const [plannedToActual, setPlannedToActual] = React.useState(null);
  const [plannedToActualLoader, setPlannedToActualLoader] = React.useState(
    false
  );
  const [timeliness, setTimeliness] = React.useState(null);
  const [timelinessLoader, setTimelinessLoader] = React.useState(false);
  const [failureToActionPlan, setFailureToActionPlan] = React.useState(null);
  const [failureToActionLoader, setFailureToActionLoader] = React.useState(
    false
  );
  const [actionPlan, setActionPlan] = React.useState(null);
  const [actionPlanLoader, setActionPlanLoader] = React.useState(false);
  const [bottomAreas, setBottomAreas] = React.useState([]);
  const [bottomAreasLoader, setBottomAreasLoader] = React.useState(false);
  const [responseData, setResponseData] = React.useState([]);
  const [responseDataLoader, setResponseDataLoader] = React.useState(false);
  const [auditFrequency, setAuditFrequency] = React.useState([]);
  const [auditFrequencyLoader, setAuditFrequencyLoader] = React.useState(false);
  const [auditQuality, setAuditorQuality] = React.useState(null);
  const [auditQualityLoader, setAuditorQualityLoader] = React.useState(false);
  const [auditTimeliness, setAuditorTimeliness] = React.useState(null);
  const [auditTimelinessLoader, setAuditorTimelinessLoader] = React.useState(
    false
  );
  const [auditMissSchedule, setAuditorMissSchedule] = React.useState(null);
  const [
    auditMissScheduleLoader,
    setAuditorMissScheduleLoader,
  ] = React.useState(false);
  const [lowPerformanceSites, setLowPerformanceSites] = React.useState(null);
  const [
    lowPerformanceSitesLoader,
    setLowPerformanceSitesLoader,
  ] = React.useState(false);
  const [weeklyInspections, setWeeklyInspections] = React.useState(null);
  const [weeklyInspectionsLoader, setWeeklyInspectionsLoader] = React.useState(
    false
  );
  const [inspectionPerformance, setInspectionPerformance] = React.useState([]);
  const [
    inspectionPerformanceLoader,
    setInspectionPerformanceLoader,
  ] = React.useState(false);
  const [frequentlyFailed, setFrequentlyFailed] = React.useState([]);
  const [frequentlyFailedLoader, setFrequentlyFailedLoader] = React.useState(
    false
  );
  const [lowestScoring, setLowestScoring] = React.useState([]);
  const [lowestScoringLoader, setLowestScoringLoader] = React.useState(false);
  const [mostFailed, setMostFailed] = React.useState([]);
  const [mostFailedLoader, setMostFailedLoader] = React.useState(false);
  const [lowestcompletion, setLowestcompletion] = React.useState([]);
  const [lowestcompletionLoader, setLowestcompletionLoader] = React.useState(
    false
  );
  const [filterApplied, setFilterApplied] = React.useState({
    Main: false,
    Dash1: false,
    Dash2: false,
    Dash3: false,
  });

  const [selectedCompany, setSelectedCompany] = React.useState(false);
  const [packageDetails, setPackageDetails] = React.useState(null);
  const [value, setValues] = React.useState({
    from: moment()
      .subtract(9, "days")
      .toDate(),
    end: new Date(),
    company_id: currentCompany,
  });
  const [openModal, setOpenModal] = React.useState(false);

  let userData = useSelector((state) => state.userReducer.user);
  let company = useSelector((state) => state.companyReducer.company);

  function handleSideBarChange(event) {
    console.log("EVENT IN COMPANY________________", event);
    setValues({
      ...value,
      [event.target.name]: event.target.value,
    });
  }

  console.log("filterApplied", filterApplied);

  async function handleSideBarSubmitAction() {
    if (filterApplied.Main == false) {
      if (tabvalue == 0 && filterApplied.Dash1 == false) {
        setFilterApplied({ ...filterApplied, Main: true, Dash1: true });
        getDash1Data();
      } else if (tabvalue == 1 && filterApplied.Dash2 == false) {
        setFilterApplied({ ...filterApplied, Main: true, Dash2: true });
        getDash2Data();
      } else if (tabvalue == 2 && filterApplied.Dash3 == false) {
        setFilterApplied({ ...filterApplied, Main: true, Dash3: true });
        getDash3Data();
      }
    } else {
      if (tabvalue == 0) {
        setFilterApplied({
          Main: true,
          Dash1: true,
          Dash2: false,
          Dash3: false,
        });
        getDash1Data();
      } else if (tabvalue == 1) {
        setFilterApplied({
          Main: true,
          Dash1: false,
          Dash2: true,
          Dash3: false,
        });
        getDash2Data();
      } else if (tabvalue == 2) {
        setFilterApplied({
          Main: true,
          Dash1: false,
          Dash2: false,
          Dash3: true,
        });
        getDash3Data();
      }
    }
  }

  async function getDash1Data() {
    setPlannedToActualLoader(true);
    setTimelinessLoader(true);
    setFailureToActionLoader(true);
    setActionPlanLoader(true);
    setBottomAreasLoader(true);
    setAuditFrequencyLoader(true);
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id: value.company_id ? value.company_id : currentCompany.id,
      from_date: value.from,
      to_date: value.end,
    };

    // let params2 = {
    //   company_id: value.company_id ? value.company_id : currentCompany.id,
    // };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    // let query2 = Object.keys(params2)
    //   .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
    //   .join("&");

    fetch(GlobalApi + "/Dashboard/plannedToActualRatio?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.msg === "success") {
          setPlannedToActualLoader(false);
          console.log(
            "DATA FROM PLANNED TO ACTUAL RATIO",
            response.plannedToActualRatio
          );
          if (isNaN(response.plannedToActualRatio)) {
            setPlannedToActual(0);
          } else {
            setPlannedToActual(response.plannedToActualRatio);
          }
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          setPlannedToActualLoader(false);
          let status = await refresh_token();
          console.log(status);
          if (status) {
            getDash1Data();
          }
        }
      })
      .catch((error) => {console.log(error.message);setPlannedToActualLoader(false);});

    fetch(GlobalApi + "/Dashboard/timelinessScore?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.msg === "success") {
          setTimelinessLoader(false);
          console.log("DATA FROM TIMELINESS SCORE", response.timelinessScore);
          if (isNaN(response.timelinessScore)) {
            setTimeliness(0);
          } else {
            setTimeliness(response.timelinessScore);
          }
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          setTimelinessLoader(false);
          let status = await refresh_token();
          console.log(status);
          if (status) {
            getDash1Data();
          }
        }
      })
      .catch((error) => {console.log(error.message); setTimelinessLoader(false);});

    fetch(GlobalApi + "/Dashboard/failureToActionPlan?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.msg === "success") {
          setFailureToActionLoader(false);
          console.log(
            "DATA FROM failureToActionPlan ",
            response.failureToActionPlan
          );
          if (response.failureToActionPlan.average == null) {
            setFailureToActionPlan(0);
          } else {
            setFailureToActionPlan(response.failureToActionPlan.average);
          }
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          setFailureToActionLoader(false);
          let status = await refresh_token();
          console.log(status);
          if (status) {
            getDash1Data();
          }
        }
      })
      .catch((error) => {console.log(error.message); setFailureToActionLoader(false);});

    fetch(GlobalApi + "/Dashboard/actionPlanResolution?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.msg === "success") {
          setActionPlanLoader(false);
          console.log(
            "DATA FROM actionPlanResolution ",
            response.actionPlanResolution
          );
          setActionPlan(response.actionPlanResolution);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          setActionPlanLoader(false);
          let status = await refresh_token();
          console.log(status);
          if (status) {
            getDash1Data();
          }
        }
      })
      .catch((error) => {console.log(error.message); setActionPlanLoader(false);});

    fetch(GlobalApi + "/Dashboard/bottom10Areas?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.msg === "success") {
          setBottomAreasLoader(false);
          console.log("DATA FROM bottom 5 Areas ", response.bottom10Areas);
          setBottomAreas(response.bottom10Areas);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          setBottomAreasLoader(false);
          let status = await refresh_token();
          console.log(status);
          if (status) {
            getDash1Data();
          }
        }
      })
      .catch((error) => {console.log(error.message); setBottomAreasLoader(false);});

    fetch(GlobalApi + "/Dashboard/auditFrequencyType?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.msg === "success") {
          setAuditFrequencyLoader(false);
          console.log(
            "DATA FROM auditFrequencyType ",
            response.auditFrequencyType
          );
          setAuditFrequency(response.auditFrequencyType);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          setAuditFrequencyLoader(false);
          let status = await refresh_token();
          console.log(status);
          if (status) {
            getDash1Data();
          }
        }
      })
      .catch((error) => {console.log(error.message);  setAuditFrequencyLoader(false);});

    setBtnLoader(false);
    setOpenModal(false);
  }

  async function getDash2Data() {
    setAuditorQualityLoader(true);
    setAuditorTimelinessLoader(true);
    setAuditorMissScheduleLoader(true);
    setLowPerformanceSitesLoader(true);
    setWeeklyInspectionsLoader(true);
    setAuditFrequencyLoader(true);
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id: value.company_id ? value.company_id : currentCompany.id,
      from_date: value.from,
      to_date: value.end,
    };

    // let params2 = {
    //   company_id: value.company_id ? value.company_id : currentCompany.id,
    // };

    console.log("PARAMS>>>>>>>>>>>>>>>>>>", params);

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    // let query2 = Object.keys(params2)
    //   .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
    //   .join("&");

    fetch(GlobalApi + "/Dashboard/qualityOfAuditor?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.msg === "success") {
          setAuditorQualityLoader(false);
          let users = [];
          let values = [];
          console.log("DATA FROM qualityOfAuditor ", response.data);
          if (response.data.length > 0) {
            response.data.forEach((item) => {
              users.push(item.user.first_name);
              values.push(item.average);
            });
          }
          setAuditorQuality({ user: users, data: values });
          console.log(users, values);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          setAuditorQualityLoader(false);
          let status = await refresh_token();
          console.log(status);
          if (status) {
            getDash2Data();
          }
        }
      })
      .catch((error) => {console.log(error.message); setAuditorQualityLoader(false);});

    fetch(GlobalApi + "/Dashboard/auditorTimeliness?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.msg === "success") {
          setAuditorTimelinessLoader(false);
          let users = [];
          let values = [];
          console.log("DATA FROM auditorTimeliness ", response.data);
          if (response.data.length > 0) {
            response.data.forEach((item) => {
              users.push(item.user.first_name);
              values.push(item.average);
            });
          }
          setAuditorTimeliness({ user: users, data: values });
          console.log(users, values);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          setAuditorTimelinessLoader(false);
          let status = await refresh_token();
          console.log(status);
          if (status) {
            getDash2Data();
          }
        }
      })
      .catch((error) => {console.log(error.message); setAuditorTimelinessLoader(false);});

    fetch(GlobalApi + "/Dashboard/auditorMissingSchedule?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.msg === "success") {
          setAuditorMissScheduleLoader(false);
          let users = [];
          let values = [];
          console.log("DATA FROM auditorMissingSchedule ", response.data);
          if (response.data.length > 0) {
            response.data.forEach((item) => {
              users.push(item.user.first_name);
              values.push(item.average);
            });
          }
          setAuditorMissSchedule({ user: users, data: values });
          console.log(users, values);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          setAuditorMissScheduleLoader(false);
          let status = await refresh_token();
          console.log(status);
          if (status) {
            getDash2Data();
          }
        }
      })
      .catch((error) => {console.log(error.message); setAuditorMissScheduleLoader(false);});

    fetch(GlobalApi + "/Dashboard/totalOfFailedItems?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.msg === "success") {
          setLowPerformanceSitesLoader(false);
          let users = [];
          let values = [];
          console.log("DATA FROM totalOfFailedItems ", response.data);
          if (response.data.length > 0) {
            response.data.forEach((item) => {
              users.push(item.title);
              values.push(item.failed_items);
            });
          }
          setLowPerformanceSites({ user: users, data: values });
          //   console.log(users , values)
          // setBtnLoader(false);
          // setModal("action", false);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          setLowPerformanceSitesLoader(false);

          let status = await refresh_token();
          console.log(status);
          if (status) {
            getDash2Data();
          }
        }
      })
      .catch((error) => {console.log(error.message); setLowPerformanceSitesLoader(false);});

    fetch(GlobalApi + "/Dashboard/inspectionConducted?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.msg === "success") {
          setWeeklyInspectionsLoader(false);
          let users = [];
          let values = [];
          console.log("DATA FROM inspectionConducted ", response);
          if (response.data.length > 0) {
            response.data.forEach((item) => {
              users.push(item.week_name);
              values.push(item.inspection_conducted);
            });
          }
          setWeeklyInspections({ user: users, data: values });
          //   console.log(users , values)
          // setBtnLoader(false);
          // setModal("action", false);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          setWeeklyInspectionsLoader(false);
          let status = await refresh_token();
          console.log(status);
          if (status) {
            getDash2Data();
          }
        }
      })
      .catch((error) => {console.log(error.message); setWeeklyInspectionsLoader(false);});

    fetch(GlobalApi + "/Dashboard/inspectionPerformance?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.msg === "success") {
          setAuditFrequencyLoader(false);
          console.log("DATA FROM inspectionPerformance ", response);

          setInspectionPerformance(response.data);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          setAuditFrequencyLoader(false);
          let status = await refresh_token();
          console.log(status);
          if (status) {
            getDash2Data();
          }
        }
      })
      .catch((error) => {console.log(error.message); setAuditFrequencyLoader(false);});

    setBtnLoader(false);
    setOpenModal(false);
  }

  async function getDash3Data() {
    setResponseDataLoader(true);
    setFrequentlyFailedLoader(true);
    setMostFailedLoader(true);
    setLowestScoringLoader(true);
    setLowestcompletionLoader(true);

    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id: value.company_id ? value.company_id : currentCompany.id,
      from_date: value.from,
      to_date: value.end,
    };

    // let params2 = {
    //   company_id: value.company_id ? value.company_id : currentCompany.id,
    // };

    console.log("PARAMS>>>>>>>>>>>>>>>>>>", params);

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    // let query2 = Object.keys(params2)
    //   .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
    //   .join("&");

    fetch(GlobalApi + "/Dashboard/response_breakdown?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.msg === "success") {
          setResponseDataLoader(false);
          console.log("DATA FROM response_breakdown ", response);
          setResponseData(response.data);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          setResponseDataLoader(false);
          let status = await refresh_token();
          console.log(status);
          if (status) {
            getDash3Data();
          }
        }
      })
      .catch((error) => {console.log(error.message); setResponseDataLoader(false);});

    fetch(GlobalApi + "/Dashboard/lowest_completion_inspection?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.msg === "success") {
          setLowestcompletionLoader(false);
          console.log("DATA FROM lowest_completion_inspection ", response);
          setLowestcompletion(response.data);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          setLowestcompletionLoader(false);
          let status = await refresh_token();
          console.log(status);
          if (status) {
            getDash3Data();
          }
        }
      })
      .catch((error) => {console.log(error.message); setLowestcompletionLoader(false);});

    fetch(GlobalApi + "/Dashboard/lowest_scoring_inspections?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.msg === "success") {
          setLowestScoringLoader(false);
          console.log("DATA FROM lowest_scoring_inspections ", response);
          setLowestScoring(response.data);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          setLowestScoringLoader(false);
          let status = await refresh_token();
          console.log(status);
          if (status) {
            getDash3Data();
          }
        }
      })
      .catch((error) => {console.log(error.message); setLowestScoringLoader(false);});

    fetch(
      GlobalApi + "/Dashboard/inspection_with_most_failed_responses?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    )
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.msg === "success") {
          setMostFailedLoader(false);
          console.log(
            "DATA FROM inspection_with_most_failed_responses ",
            response
          );
          setMostFailed(response.data);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          setMostFailedLoader(false);
          let status = await refresh_token();
          console.log(status);
          if (status) {
            getDash3Data();
          }
        }
      })
      .catch((error) => {console.log(error.message); setMostFailedLoader(false);});

    fetch(GlobalApi + "/Dashboard/frequently_failed_items?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.msg === "success") {
          setFrequentlyFailedLoader(false);
          console.log("DATA FROM frequently_failed_items ", response);
          setFrequentlyFailed(response.data);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          setFrequentlyFailedLoader(false);
          let status = await refresh_token();
          console.log(status);
          if (status) {
            getDash3Data();
          }
        }
      })
      .catch((error) => {console.log(error.message); setFrequentlyFailedLoader(false);});
    setBtnLoader(false);
    setOpenModal(false);
  }

  const handleChange = (event, newValue) => {
    if (
      newValue == 0 &&
      filterApplied.Dash1 == false &&
      filterApplied.Main == true
    ) {
      setFilterApplied({ ...filterApplied, Main: true, Dash1: true });
      getDash1Data();
    } else if (
      newValue == 1 &&
      filterApplied.Dash2 == false &&
      filterApplied.Main == true
    ) {
      setFilterApplied({ ...filterApplied, Main: true, Dash2: true });
      getDash2Data();
    } else if (
      newValue == 2 &&
      filterApplied.Dash3 == false &&
      filterApplied.Main == true
    ) {
      setFilterApplied({ ...filterApplied, Main: true, Dash3: true });
      getDash3Data();
    }
    setTabValue(newValue);
  };

  if (localStorage.getItem("UserData") === null) {
    return <Redirect to={"/signin"} />;
  }
  var retrievedData = localStorage.getItem("UserData");
  var data = JSON.parse(retrievedData);
  if (data.token == null) {
    return <Redirect to={"/signin"} />;
  }
  return <>
      <MiddleHeader />
      <div className="" style={{ width: "100%", padding: "20px", marginBottom: "0px", overflow: "auto", backgroundColor: "#eaf7fe" }}>
        <Grid justifyContent="center" alignItems="center" xs={12} sm={12} md={12} style={{ backgroundColor: "white", padding: "0px ", borderRadius: "5px", overflow: "hidden", boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)", marginBottom: "0px", width: "100%" }}>
          <Grid container direction="row" justifyContent="space-between" alignItems="center" style={{ backgroundColor: "white", padding: "10px", borderBottom: "1px solid #dadada", justifyContent: "space-between" }}>
            <Grid item xs={12} md={4}>
              <p className="label2" style={{ marginBottom: 0, marginTop: window.innerWidth > 500 ? 0 : 10, fontSize: 14, color: Colors.globalColor8, fontWeight: "bolder", display: "block", textTransform: "uppercase" }}>
                {t("Executive Dashboard")}
              </p>
            </Grid>

            <Grid item xs={12} md={6}>
              {/* For Web */}
              {window.innerWidth > 700 && <AntTabs className="scheduleTabHeader" style={{ color: Colors.buttonTextColor }} value={tabvalue} onChange={handleChange} aria-label="simple tabs example">
                  <Tab className="templateTab" style={{ marginTop: "5px", textTransform: "uppercase", fontSize: language == "ar" ? 18 : 12, fontWeight: "bold", backgroundColor: tabvalue == 0 ? Colors.globalColor9 : "transparent", color: tabvalue == 0 ? "#1a73e8" : "black" }} label={t("Overview")} />
                  <Tab className="templateTab" style={{ marginTop: "5px", textTransform: "uppercase", fontSize: language == "ar" ? 18 : 12, fontWeight: "bold", backgroundColor: tabvalue == 1 ? Colors.globalColor9 : "transparent", color: tabvalue == 1 ? "#1a73e8" : "black" }} label={t("Inspector Performance")} />
                  <Tab className="templateTab" style={{ marginTop: "5px", textTransform: "uppercase", fontSize: language == "ar" ? 18 : 12, fontWeight: "bold", backgroundColor: tabvalue == 2 ? Colors.globalColor9 : "transparent", color: tabvalue == 2 ? "#1a73e8" : "black" }} label={t("Failed Inspection")} />
                </AntTabs>}
              {/* For Tab */}
              {window.innerWidth > 500 && window.innerWidth <= 700 && <AntTabs className="scheduleTabHeader2" style={{ color: Colors.buttonTextColor }} value={tabvalue} onChange={handleChange} aria-label="simple tabs example">
                  <Tab className="scheduleTab2" style={{ marginTop: "5px", textTransform: "uppercase", fontSize: language == "ar" ? 18 : 12, fontWeight: "bold", backgroundColor: tabvalue == 0 ? Colors.globalColor9 : "transparent", color: tabvalue == 0 ? "#1a73e8" : "black"  }} label={t("Overview")} />
                  <Tab className="scheduleTab2" style={{ marginTop: "5px", textTransform: "uppercase", fontSize: language == "ar" ? 18 : 12, fontWeight: "bold", backgroundColor: tabvalue == 1 ? Colors.globalColor9 : "transparent", color: tabvalue == 1 ? "#1a73e8" : "black"  }} label={t("Inspector Performance")} />
                  <Tab className="scheduleTab2" style={{ marginTop: "5px", textTransform: "uppercase", fontSize: language == "ar" ? 18 : 12, fontWeight: "bold", backgroundColor: tabvalue == 2 ? Colors.globalColor9 : "transparent", color: tabvalue == 2 ? "#1a73e8" : "black"  }} label={t("Failed Inspection")} />
                </AntTabs>}
              {/* For Mobile */}
              {window.innerWidth <= 500 && <AntTabs className="scheduleTabHeader" style={{ color: Colors.buttonTextColor }} value={tabvalue} onChange={handleChange} aria-label="simple tabs example">
                  <Tab className="scheduleTab3" style={{ marginTop: "5px", textTransform: "uppercase", fontSize: language == "ar" ? 14  : 12, fontWeight: "bold", backgroundColor: tabvalue == 0 ? Colors.globalColor9 : "transparent", color: tabvalue == 0 ? "#1a73e8" : "black" }} label={t("Overview")} />
                  <Tab className="scheduleTab3" style={{ marginTop: "5px", textTransform: "uppercase", fontSize: language == "ar" ? 14  : 12, fontWeight: "bold", backgroundColor: tabvalue == 1 ? Colors.globalColor9 : "transparent", color: tabvalue == 1 ? "#1a73e8" : "black"   }} label={t("Inspector Performance")} />
                  <Tab className="scheduleTab3" style={{ marginTop: "5px", textTransform: "uppercase", fontSize: language == "ar" ? 14  : 12, fontWeight: "bold", backgroundColor: tabvalue == 2 ? Colors.globalColor9 : "transparent", color: tabvalue == 2 ? "#1a73e8" : "black"  }} label={t("Failed Inspection")} />
                </AntTabs>}
            </Grid>

            <Grid item xs={12} md={2} style={{ textAlign: "right" }}>
              <div style={{ cursor: "pointer", justifyContent: window.innerWidth > 700 ? "flex-end" : "center", display: "flex", alignItems: "center", marginBottom: window.innerWidth > 500 ? 0 : 10, flexDirection: "row", padding: "0px 10px", height: "100%" }} onClick={() => {
                  setOpenModal(true);
                }}>
                <img src={Filter} width={25} />
                &nbsp;
                <p className="filterHeading" style={{ color: "#1E68EC", fontSize: 12, fontWeight: "bold", marginTop: 0, marginBottom: 0 }}>
                  {t("Filter")}
                </p>
              </div>
            </Grid>
          </Grid>

          <div>
            <TabPanel value={tabvalue} index={0}>
              <Dashboard1 plannedToActual={plannedToActual} plannedToActualLoader={plannedToActualLoader} timeliness={timeliness} timelinessLoader={timelinessLoader} failureToActionPlan={failureToActionPlan} failureToActionLoader={failureToActionLoader} actionPlan={actionPlan} actionPlanLoader={actionPlanLoader} bottomAreas={bottomAreas} bottomAreasLoader={bottomAreasLoader} auditFrequency={auditFrequency} auditFrequencyLoader={auditFrequencyLoader} companyID={value.company_id} from={value.from} to={value.end} />
            </TabPanel>
            <TabPanel value={tabvalue} index={1}>
              <Dashboard2 auditQuality={auditQuality} auditQualityLoader={auditQualityLoader} auditTimeliness={auditTimeliness} auditTimelinessLoader={auditTimelinessLoader} auditMissSchedule={auditMissSchedule} auditMissScheduleLoader={auditMissScheduleLoader} lowPerformanceSites={lowPerformanceSites} lowPerformanceSitesLoader={lowPerformanceSitesLoader} weeklyInspections={weeklyInspections} weeklyInspectionsLoader={weeklyInspectionsLoader} inspectionPerformance={inspectionPerformance} inspectionPerformanceLoader={inspectionPerformanceLoader} companyID={value.company_id} from={value.from} to={value.end} />
            </TabPanel>
            <TabPanel value={tabvalue} index={2}>
              <Dashboard3 frequentlyFailed={frequentlyFailed} frequentlyFailedLoader={frequentlyFailedLoader} lowestScoring={lowestScoring} lowestScoringLoader={lowestScoringLoader} mostFailed={mostFailed} mostFailedLoader={mostFailedLoader} lowestcompletion={lowestcompletion} lowestcompletionLoader={lowestcompletionLoader} responseData={responseData} responseDataLoader={responseDataLoader} companyID={value.company_id} from={value.from} to={value.end} />
            </TabPanel>
          </div>
        </Grid>
      </div>

      <Dialog onClose={() => {
          setOpenModal(false);
        }} aria-labelledby="max-width-dialog-title" open={openModal} fullWidth={true} maxWidth={"sm"} scroll={"paper"} className="executiveDashModal">
        <React.Fragment>
          <Grid item xs={12} style={{ alignSelf: "flex-end", cursor: "pointer" }} onClick={() => {
              setOpenModal(false);
            }}>
            <CloseIcon fontSize="medium" style={{ color: "#043077" }} />
          </Grid>
          <SearchBar value={value} handleSideBarSubmit={handleSideBarSubmitAction} handleSideBarChange={handleSideBarChange} // templates={templates}
            // inspections={inspections}
            // sites={sites}
            companies={companies} packageDetails={packageDetails} btnLoader={btnLoader} setBtnLoader={setBtnLoader} selectedCompany={selectedCompany ? selectedCompany : currentCompany} setSelectedCompany={setSelectedCompany} />
        </React.Fragment>
      </Dialog>
    </>;
}
// [auditFrequency?.custom_month_avg,auditFrequency?.custom_week_avg,auditFrequency?.custom_day_avg,auditFrequency?.every_month_avg,auditFrequency?.every_week_avg,auditFrequency?.every_weekDay_avg,auditFrequency?.one_off_avg]